// Google Analytics 4 (gtag.js) initialization for the Aidify site.
//
// CRA only inlines env vars prefixed with REACT_APP_ into the browser bundle,
// and only at build time. The GA4 Measurement ID is a public tag identifier
// (not a secret), but we still read it from an env var so it stays out of the
// source and can differ per environment.
//
// Guard: if REACT_APP_GA_MEASUREMENT_ID is missing (e.g. local dev without it,
// or a build where the var wasn't set), initGA() no-ops instead of crashing.
const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export function initGA() {
  // No ID configured, or not running in a browser (e.g. SSR/tests) — do nothing.
  if (!MEASUREMENT_ID || typeof window === "undefined" || typeof document === "undefined") {
    return;
  }

  // Avoid double-injecting the script (e.g. React StrictMode double-invoke,
  // or hot reloads in development).
  if (window.__gaInitialized) {
    return;
  }
  window.__gaInitialized = true;

  // Inject the standard gtag.js loader as the first async script.
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(script);

  // Standard gtag bootstrap snippet.
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag("js", new Date());
  gtag("config", MEASUREMENT_ID);
}
